import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
});

// Auto-reload when a new service worker activates and takes control.
// With skipWaiting + clientsClaim in the workbox config, the new SW
// claims the page immediately — this listener reloads so the user
// gets the new assets without manual intervention.
let isFirstSW = !navigator.serviceWorker?.controller;
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  // Don't reload on first load (initial SW install), only on updates
  if (isFirstSW) {
    isFirstSW = false;
    return;
  }
  // Set global flag so beforeunload handlers skip the confirmation dialog.
  // This ensures the reload cannot be cancelled by a "Leave page?" prompt.
  window.__swUpdating = true;
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);